import script from "./TotaisReceitasPie.vue?vue&type=script&setup=true&lang=js"
export * from "./TotaisReceitasPie.vue?vue&type=script&setup=true&lang=js"

import "./TotaisReceitasPie.vue?vue&type=style&index=0&id=18aa72e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18aa72e8"]])

export default __exports__